import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore, CACHE_SIZE_UNLIMITED } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCVaG46CkRRnXdO3QWvOJToeXUUFGpZdrE",
  authDomain: "yashasvibhava-926e0.firebaseapp.com",
  databaseURL: "https://yashasvibhava-926e0-default-rtdb.firebaseio.com",
  projectId: "yashasvibhava-926e0",
  storageBucket: "yashasvibhava-926e0.firebasestorage.app",
  messagingSenderId: "615589366013",
  appId: "1:615589366013:web:fd61823cab13a6aa481694",
  measurementId: "G-Q0YBP4JTE4"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with cache disabled for fresh data
export const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  experimentalForceLongPolling: false,
  ignoreUndefinedProperties: true
});

// Initialize Storage
export const storage = getStorage(app);

export default app;
